import { usePolicyMapper as NEWUsePolicyMapper } from "./usePolicyMapper";

export function usePolicyMapper(policyNumber) {
  return NEWUsePolicyMapper(policyNumber);
}
